import { useState } from 'react'
import { Box, IconButton, Drawer, Typography, List, ListItem, Button } from '@mui/material'
import BugReportIcon from '@mui/icons-material/BugReport'
import { useDevLog } from './useDevLog'

export function DevPanel() {
  const [open, setOpen] = useState(false)
  const entries = useDevLog((s) => s.entries)
  const clear = useDevLog((s) => s.clear)
  if (!import.meta.env.DEV) return null
  return (
    <>
      <IconButton
        sx={{ position: 'fixed', bottom: 16, right: 16, zIndex: 1500 }}
        onClick={() => setOpen(true)}
        color="warning"
      >
        <BugReportIcon />
      </IconButton>
      <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
        <Box sx={{ width: 480, p: 2 }}>
          <Typography variant="h6">Dev panel</Typography>
          <Button size="small" onClick={clear}>
            Clear
          </Button>
          <List dense>
            {entries.map((e) => (
              <ListItem key={e.id}>
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    {new Date(e.ts).toLocaleTimeString()} — {e.kind}
                  </Typography>
                  <Typography variant="body2">{e.message}</Typography>
                  {e.detail ? (
                    <pre style={{ fontSize: 11 }}>{JSON.stringify(e.detail, null, 2)}</pre>
                  ) : null}
                </Box>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </>
  )
}
